
import PropTypes from "prop-types";
import { useState } from "react";
import { Typography, TextField } from "@mui/material";


function AccountReference({
  label,
  inputLabel,
  formState,
  setFormState,
  setFormError,
  minLength,
  maxLength,
  alphaNumeric = false,
  specialCharacters = false
}) {
  const [value, setValue] = useState("");

  function onChange(e) {
    const inputValue = e.target.value;
    let inputValid = false;

    if (alphaNumeric) {
      // Alphanumeric allowed
      const alphanumericRegex = /^[a-z0-9]+$/i;
      inputValid = alphanumericRegex.test(inputValue);
    } else {
      // Numeric only
      const numericRegex = /^(?!.*\s).*$/;
      inputValid = !isNaN(inputValue) && numericRegex.test(inputValue);
    }
    if (maxLength && inputValue.length > maxLength) {
      return;
    }

    if (inputValid) {
      setValue(inputValue);
      if (!minLength || inputValue.length >= minLength) {
        setFormState({
          ...formState,
          [e.target.name]: e.target.value,
        });
        setFormError(null);
      } else {
        setFormState({ ...formState, [e.target.name]: null });
        setFormError(`Minimum ${minLength} characters required.`);
      }
    }
  }

  return (
    <>
      <Typography
        id='accountReferenceLabel'
        component='label'
        htmlFor='accountReferenceInput'
        sx={{
          fontWeight: "bold"
        }}
      >
        {label}
      </Typography>
      <TextField
        id='accountReferenceInput'
        margin='dense'
        required
        fullWidth
        label={inputLabel}
        name='accountReference'
        autoFocus
        onChange={onChange}
        value={value}
        inputProps={{ minLength, maxLength }}
      />
    </>
  );
};

const validateAccountReference = (accountReference) => {
  let accountReferenceValid = true;
  return accountReferenceValid;
};

AccountReference.propTypes = {
  label: PropTypes.string.isRequired,
  inputLabel: PropTypes.string.isRequired,
  formState: PropTypes.object.isRequired,
  setFormState: PropTypes.func.isRequired,
  setFormError: PropTypes.func.isRequired,
  alphaNumeric: PropTypes.bool.isRequired,
  minLength: PropTypes.number,
  maxLength: PropTypes.number,
  specialCharacters: PropTypes.bool.isRequired,
};

export { AccountReference, validateAccountReference };